<template>
  <QS-column-box
    v-if="buildStatus"
    :source="transeferSource"
    :column="columnNum"
    :list="detailOptions"
    separator=":"
  >
    <template v-slot:attachment>
      <show-img-and-file :list="transeferSource.attachment" />
    </template>
    <template v-slot:fileUrl>
      <a :href="transeferSource.fileUrl">{{ transeferSource.fileUrlName }}</a>
    </template>
  </QS-column-box>
</template>

<script>
import selectOption from '@/store/dict/selectOptionDict'
import {
  finceOriginalOptions,
  finceCommonOriginalOptions,
  approvalOriginalOptions,
} from './config.js'

const _map = new Map([['receivable', '收款'], ['payment', '付款']])
const originalOptionsMapper = new Map([
  [1, approvalOriginalOptions],
  [2, finceCommonOriginalOptions],
  [3, finceOriginalOptions],
])
const detailOptions = (scenetypeDesc) => [
  {
    key: 'id',
    name: `批量${scenetypeDesc}ID`,
    alone: true,
  },
  {
    key: 'amount',
    name: `${scenetypeDesc}总金额（元）`,
    alone: true,
  },
  {
    key: 'fileUrl',
    name: `${scenetypeDesc}明细（原文件）`,
    alone: true,
  },
  {
    key: 'attachment',
    name: `${scenetypeDesc}凭证`,
    alone: true,
  },
  {
    key: 'remarks',
    name: '备注',
    alone: true,
  },
]

/** 目前收集系统中使用该业务功能的有 三种入口场景 enterScene : { 1, 2, 3}
 * 1. 审批中
 * 2. 财务 公共组件有一个 两个二级入口使用
 *     2.2 src/pages/orders/components/collectionDetails.vue
 * 3. 财务模块 批量付款详情
 * */

export default {
  name: 'CollectionRecordDetailsTableForm',
  data() {
    return {
      buildStatus: false,
    }
  },
  props: {
    scenetype: String,
    enterScene: Number,
    source: {
      type: Object,
      default: () => ({}),
    },
  },
  watch: {
    source(n) {
      this.buildStatus = Object.keys(n).length > 0
    },
    columnNum(n, o) {
      if (n === o) return
      this.buildStatus = false
      this.$nextTick(() => {
        this.buildStatus = true
      })
    },
  },
  computed: {
    scenetypeDesc() {
      return _map.get(this.scenetype) || '--'
    },
    columnNum() {
      return this.source?.fileUrl ? 1 : 2
    },
    detailOptions() {
      if (this.source?.fileUrl) {
        return detailOptions(this.scenetypeDesc)
      }
      return originalOptionsMapper.get(Number(this.enterScene)) || {}
    },
    transeferSource() {
      const output = { ...this.source }
      const {
        source: { customerType, attachment },
      } = this
      if (customerType) {
        output.customerTypeName =
          selectOption.customerTypeDict[customerType] || '--'
      }
      output.attachment = []
      if (attachment) {
        output.attachment =
          this.getURL({
            data: attachment,
            needName: true,
          })
      }
      if (output.fileUrl) {
        const urlArr = this.getURL({
          data: output.fileUrl,
          needName: true,
        })
        output.fileUrl = urlArr?.[0]?.url || ''
        output.fileUrlName = urlArr?.[0]?.name || ''
      }


      return output
    },
  },
}
</script>

<style lang="scss" scoped>
::v-deep .el-column-box__title {
  text-align: right;
  width: 150px;
}
.attachment-image {
  display: flex;
  ::v-deep .imgDiv {
    margin-right: 10px;
  }
}
.file_item {
  width: 100%;
  color: #276bec;
  cursor: pointer;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-line-clamp: 1;
  display: -webkit-box;
  -webkit-box-orient: vertical;
}
</style>
